/**
 * Advanced example demonstrating all core MobX constructs.
 */
import { makeAutoObservable } from "mobx";

class ProfileStore {
  // ====================================================
  // State
  // ====================================================
  user = null;
  count = 0;
  error = null;

  loadingMe = false;
  me = [];
  currentAccType = "";

  constructor() {
    makeAutoObservable(this);
  }

  // ====================================================
  // Computed views

  // ====================================================
  // While MobX promotes OOP, we can still benefit from using FP where it's appropriate

  // ====================================================
  // Actions
  // ====================================================

  toggleFilter = () => {
    this.filter = !this.filter;
  };
  updateProfileInfo = (profileInfo) => {
    this.loadingMe = true;
    this.me = profileInfo;
    this.loadingMe = false;
  };
  setAccType = (acctype) => {
    this.currentAccType = acctype;
  };

  // Drops the previous user's profile data on logout / account switch so it
  // can't leak into the next session before fresh data loads.
  reset = () => {
    this.user = null;
    this.me = [];
    this.currentAccType = "";
    this.error = null;
    this.loadingMe = false;
  };
}

export default new ProfileStore();
